(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-moodie-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nv-moodie-reviews'))customElements.define('nv-moodie-reviews',class extends HTMLElement{
 connectedCallback(){if(this._abort)return;this._abort=new AbortController();const button=this.querySelector('[data-motion-toggle]');if(button)button.addEventListener('click',()=>{const paused=this.dataset.paused!=='true';this.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.textContent=paused?(button.dataset.resume||'Resume images'):(button.dataset.pause||'Pause images');},{signal:this._abort.signal});}
 disconnectedCallback(){if(this._abort)this._abort.abort();this._abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nv-product-hero"] && !Shopify.designMode) return;
  try {
    
// Build one request: the selected pillow kit plus individual gels OR the trio.
function nvGelCartItems(mainId, quantity, journey, choices, trio) {
  if (!mainId || !Number.isInteger(quantity) || quantity < 1) throw new Error('Please select an available kit.');
  const items = [{id: String(mainId), quantity, properties: {_Jornada: journey || ''}}];
  if (trio && trio.checked && !trio.disabled && trio.value) {
    items.push({id: String(trio.value), quantity: 1});
  } else {
    choices.filter(gel => gel.checked && !gel.disabled && gel.value).forEach(gel => items.push({id: String(gel.value), quantity: 1}));
  }
  return items;
}
function nvSetupGelBump(scope) {
  const form = scope.querySelector('form.nv-product-form');
  if (!form || form.dataset.gelInitialized) return;
  form.dataset.gelInitialized = 'true';
  // The gel block is optional: without it, the form is still intercepted to go straight to checkout.
  const bump = scope.querySelector('[data-amx-gel]') || form;
  const gels = [...bump.querySelectorAll('[data-amx-gel-item]')];
  const trio = bump.querySelector('[data-amx-gel-all]');
  // Optional products always start unchecked, including browser-restored state.
  gels.forEach(gel => gel.checked = false);
  if (trio) {
    trio.checked = false;
    trio.addEventListener('change', () => gels.forEach(gel => gel.checked = trio.checked && !gel.disabled));
  }
  gels.forEach(gel => gel.addEventListener('change', () => {
    if (trio) trio.checked = !trio.disabled && gels.length === 3 && gels.every(item => item.checked && !item.disabled);
  }));
  let error = bump.querySelector('[data-amx-gel-error]');
  if (!error) { error = document.createElement('p'); error.className = 'nv-form-error'; error.hidden = true; error.setAttribute('role', 'alert'); form.appendChild(error); }
  const button = form.querySelector('[type="submit"]');
  form.addEventListener('submit', async event => {
    if (form.dataset.gelSubmitting === 'true') { event.preventDefault(); return; }
    const main = form.querySelector('input[name="id"]:checked:not(:disabled)');
    if (!main) { event.preventDefault(); error.textContent = 'Please select an available kit.'; error.hidden = false; return; }
    const items = nvGelCartItems(main.value, Number(form.elements.quantity.value), form.elements['properties[_Jornada]']?.value, gels, trio);
    // Always intercept: with or without gel, add via API and go straight to the configured destination (checkout by default).
    event.preventDefault();
    form.dataset.gelSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.hidden = true;
    let added = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status >= 400) throw new Error(result.description || 'We couldn\'t add the items. Please check availability and try again.');
      added = true;
      const goto = form.dataset.afterAdd === 'cart' ? (bump.dataset.cartUrl || root + 'cart') : root + 'checkout';
      window.location.assign(goto);
    } catch (err) {
      error.textContent = err.message === 'Failed to fetch' ? 'We couldn\'t confirm the items were added. Please check your bag before trying again.' : err.message;
      error.hidden = false;
    } finally {
      if (!added) { form.dataset.gelSubmitting = 'false'; button.disabled = false; button.removeAttribute('aria-busy'); }
    }
  });
}

if (!customElements.get('nv-offer-controller')) {
 class NvOfferController extends HTMLElement {
  connectedCallback() {
   const scope = this.closest('.shopify-section');
   if (!scope || scope.dataset.nvInitialized) return;
   scope.dataset.nvInitialized = 'true';
   nvSetupGelBump(scope);
   const main = scope.querySelector('.nv-gallery-main');
   const changeImage = (src, alt) => { if (main && src) { main.removeAttribute('srcset'); main.src = src; if (alt) main.alt = alt; } };
   scope.querySelectorAll('[data-gallery-src]').forEach((button,index) => {button.setAttribute('aria-pressed',String(index===0));button.addEventListener('click', () => {changeImage(button.dataset.gallerySrc, button.dataset.galleryAlt);scope.querySelectorAll('[data-gallery-src]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});});
   scope.querySelectorAll('input[name="id"]').forEach(input => input.addEventListener('change', () => {
    const price = scope.querySelector('[data-sticky-price]');
    const pix = scope.querySelector('[data-pix-price]');
    document.querySelectorAll('[data-night-price]').forEach(e => e.textContent = new Intl.NumberFormat('en-US', {style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'}).format(Number(input.dataset.priceCents)/100/30));
    document.querySelectorAll('[data-stock-signal]').forEach(e => {const qty=Number(input.dataset.inventory);e.hidden=!(qty>0&&qty<=20);e.querySelector('[data-stock-number]').textContent=qty;});
    if (price) price.textContent = input.dataset.price;
    scope.querySelectorAll('[data-selected-kit]').forEach(e => e.textContent = input.dataset.title);
    document.querySelectorAll('[data-final-selected-price]').forEach(e => e.textContent = input.dataset.price);
    const featurePrice = scope.querySelector('[data-feature-price]');
    if (featurePrice) featurePrice.textContent = input.dataset.price;
    const compareLabel=scope.querySelector("[data-compare-label]");if(compareLabel)compareLabel.hidden=!input.dataset.compare;
    const comparePrice=scope.querySelector("[data-compare-price]"); if(comparePrice){comparePrice.hidden=!input.dataset.compare;comparePrice.textContent=input.dataset.compare||"";}
    if (pix) pix.textContent = input.dataset.pix;
    changeImage(input.dataset.image, input.dataset.imageAlt);
    if (window.location.pathname.includes('/products/')) { const url = new URL(window.location.href); url.searchParams.set('variant', input.value); history.replaceState({}, '', url); }
   }));
   const checked = scope.querySelector('input[name="id"]:checked');
   if (checked) checked.dispatchEvent(new Event('change', { bubbles: true }));
  }
 }
 customElements.define('nv-offer-controller', NvOfferController);
}

  } catch(e) { console.error(e); }
})();
})();
